import { createContext } from "react";

const PersonalSlipContext = createContext();

export default PersonalSlipContext;
